// Pages
import { ActivityTeacherCreate } from "./activity-teacher-create.page";

export default ActivityTeacherCreate;
